import { Overrides } from "@material-ui/core/styles/overrides"
import { baseTheme } from "theme/base"
import { buttonsStatesColors } from "./constants"

export const MuiButton: Overrides["MuiButton"] = {
  root: {
    "&$outlined, &$outlinedPrimary, &$outlinedSecondary": {
      borderColor: "inherit",
      borderWidth: "2px",
      "&:hover, &$disabled": {
        borderColor: "inherit",
        borderWidth: "2px",
      },
    },
    "&$disabled": {
      color: baseTheme.palette.grey[500],
    },
    lineHeight: "1.6rem",
    minHeight: "4rem",
    minWidth: 0,
    textTransform: "initial",
    transition:
      "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1), border-color 250ms cubic-bezier(0.4, 0, 0.2, 1), color 250ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  sizeLarge: {
    padding: "0.6rem 1.6rem",
    fontSize: "1.4rem",
  },
  contained: {
    "&$disabled": {
      backgroundColor: baseTheme.palette.grey[100],
      color: baseTheme.palette.grey[500],
    },
  },
  containedPrimary: buttonsStatesColors.containedPrimary,
  containedSecondary: buttonsStatesColors.containedSecondary,
  outlinedPrimary: buttonsStatesColors.outlinedPrimary,
  outlinedSecondary: buttonsStatesColors.outlinedSecondary,
  textPrimary: buttonsStatesColors.outlinedPrimary,
  textSecondary: buttonsStatesColors.outlinedSecondary,
}
